import TablePagination from "@mui/material/TablePagination";

export interface PaginationFooterProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (e: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
  onRowsPerPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
}

/** Standard paginator footer for data lists. Default row options: 25 / 50 / 100. */
export function PaginationFooter({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [25, 50, 100],
}: PaginationFooterProps) {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
}
